module.exports = __webpack_public_path__ + "static/media/send_email_icon.15d14b78.svg";